import { String, Subtitle, Button, Theme } from '@silvertours/front-shared';
import Image from 'next/image';
import { useMedia } from 'react-use';
import { useTranslations } from 'next-intl';
import { useSiteInfo } from '../../SiteInfo';
import { useLocale } from '../../Runtime';
import {
  Anchor,
  ContactInfo,
  InteractivePhoneNumber,
  PhoneNumberHint,
  PopoverWrapper,
  StyledOpeningTimesSchedule,
  VoucherExplanation,
  VoucherInfo,
} from './SupportPopover.styles';
import email from './email.png';
import call from './call.png';

type SupportPopoverProps = {
  showHeader?: boolean;
  showNumber?: boolean;
};

const SupportPopover = ({
  showHeader = true,
  showNumber = true,
}: SupportPopoverProps) => {
  const {
    settings: { phoneNumber, language },
  } = useSiteInfo();
  const { market } = useLocale();

  const formattedNumber = String.parsePhoneNumber(phoneNumber, language);
  const phoneNumberText =
    market === 'CH' ? formattedNumber.international : formattedNumber.national;

  const isMobile = useMedia(
    `(max-width: ${Theme.getBreakpoint('lg')}px)`,
    false,
  );
  const t = useTranslations('features.supportInfo');

  const linkProps = {
    target: '_blank',
    rel: 'noopener noreferrer nofollow',
    fullWidth: true,
  };

  const voucherHref =
    market === 'CH'
      ? 'https://www.billiger-mietwagen.ch/de-ch/reservation/voucher'
      : t('voucher.buttonHref');

  return (
    <PopoverWrapper onTouchMove={e => e.stopPropagation()}>
      <ContactInfo>
        {showHeader && <Subtitle as="p">{t('headline')}</Subtitle>}

        <Image src={email} alt="" width="185" height="150" unoptimized />
        <Button variant="primary" href={t('contact.buttonHref')} {...linkProps}>
          {t('contact.buttonLabel')}
        </Button>

        {showNumber && (
          <>
            <Image src={call} alt="" width="185" height="150" unoptimized />
            {isMobile ? (
              <Button href={formattedNumber.url} variant="secondary" fullWidth>
                {phoneNumberText}
              </Button>
            ) : (
              <InteractivePhoneNumber textColor="green">
                <Anchor href={formattedNumber.url}>{phoneNumberText}</Anchor>
              </InteractivePhoneNumber>
            )}
            {market === 'CH' && (
              <PhoneNumberHint>
                (aus der Schweiz zum Auslandstarif)
              </PhoneNumberHint>
            )}
            <StyledOpeningTimesSchedule />
          </>
        )}
      </ContactInfo>

      <VoucherInfo>
        <Button variant="secondary" href={voucherHref} {...linkProps}>
          {t('voucher.buttonLabel')}
        </Button>
        <VoucherExplanation textColor="grey">
          {t('voucher.text')}
        </VoucherExplanation>
      </VoucherInfo>
    </PopoverWrapper>
  );
};

export { SupportPopover };
